module.exports = {
  APPLICATION_CONFIGURATION_KEY: "__NOTARIZE_RUNTIME_CONFIGURATION__",
  APP_CONTAINER_ELEM_ID: "app",
  UNSUPPORTED_BROWSER_ELEM_ID: "UnsupportedBrowserContainer",
  FAVICON_ID: "notarize-favicon",
  GRAPHQL_DOCUMENT_ID_PROP_NAME: "notarizeId",
};
